import { type ButtonType } from './types'

export const isIconButton = (type: ButtonType): boolean => {
  return type === 'icon-rounded' || type === 'icon-full'
}
